import React, {Fragment, memo} from 'react';
import Dict from "./DictObj";
import List from "./ListObj";
import {previewPrimitive} from "../utils/json";

const Val = memo(({keyClicked, value, collapseAll}) => {
    let render_result;

    if (Array.isArray(value)){
        render_result = keyClicked?<Fragment>{"[...]"}</Fragment>:<List value={value} collapseAll={collapseAll}/>
    }else if (value===null){
        render_result = <Fragment>{String(value)}</Fragment>
    }else if (value===undefined){
        render_result = <Fragment>{value}</Fragment>
    }else if (typeof(value)==='object'){
        render_result = keyClicked?<Fragment>{"{...}"}</Fragment>:<Dict obj={value} collapseAll={collapseAll}/>
    }else{
        // Primitive: when collapsed, show a truncated preview of long values.
        render_result = keyClicked
            ? <Fragment>{previewPrimitive(value)}</Fragment>
            : <Fragment>{String(value)}</Fragment>
    }

    return (
        render_result
    )

})

export default Val;
